r<template>
  <div class="perfil-page">
    <SGPRowComponent class="justify-content-center">
      <SGPColComponent cols="12" md="8" lg="6">
        <div class="perfil-header">
          <div class="avatar-container">
            <span class="nome-avatar">
              <strong>{{ nomeAvatar }}</strong>
            </span>
          </div>
          <h2 class="text-center mt-3 mb-5">{{ usuarioLogado.nome }}</h2>
        </div>

        <v-card class="mb-4">
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-account</v-icon>
            Informações Pessoais
          </v-card-title>
          <v-card-text>
            <SGPRowComponent>
              <SGPColComponent cols="12" md="6">
                <SGPFormInputComponent
                  label="Nome"
                  v-model="dadosUsuario.name"
                  placeholder="Digite seu nome"
                  :disabled="!editandoDados"
                />
              </SGPColComponent>
              <SGPColComponent cols="12" md="6">
                <SGPFormInputComponent
                  label="E-mail"
                  v-model="dadosUsuario.email"
                  placeholder="Digite seu e-mail"
                  type="email"
                  :disabled="!editandoDados"
                />
              </SGPColComponent>
            </SGPRowComponent>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <SGPFormBotaoComponent
              v-if="!editandoDados"
              @click="habilitarEdicao"
              color="primary"
              outlined
            >
              <v-icon left>mdi-pencil</v-icon>
              Editar Informações
            </SGPFormBotaoComponent>
            <template v-else>
              <SGPFormBotaoComponent
                @click="cancelarEdicao"
                color="grey"
                outlined
                class="mr-2"
              >
                Cancelar
              </SGPFormBotaoComponent>
              <SGPFormBotaoComponent
                @click="salvarDados"
                color="primary"
                :disabled="loadingUsuario"
              >
                <v-icon left>mdi-content-save</v-icon>
                Salvar
              </SGPFormBotaoComponent>
            </template>
          </v-card-actions>
        </v-card>

        <v-card class="mb-4">
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-lock</v-icon>
            Alterar Senha
          </v-card-title>
          <v-card-text>
            <SGPRowComponent>
              <SGPColComponent cols="12">
                <SGPFormInputComponent
                  label="Senha Atual"
                  v-model="senhaData.senha_atual"
                  placeholder="Digite sua senha atual"
                  type="password"
                  :disabled="!editandoSenha"
                />
              </SGPColComponent>
              <SGPColComponent cols="12" md="6">
                <SGPFormInputComponent
                  label="Nova Senha"
                  v-model="senhaData.nova_senha"
                  placeholder="Digite a nova senha"
                  type="password"
                  :disabled="!editandoSenha"
                />
              </SGPColComponent>
              <SGPColComponent cols="12" md="6">
                <SGPFormInputComponent
                  label="Confirmar Nova Senha"
                  v-model="senhaData.confirmar_senha"
                  placeholder="Confirme a nova senha"
                  type="password"
                  :disabled="!editandoSenha"
                />
              </SGPColComponent>
            </SGPRowComponent>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <SGPFormBotaoComponent
              v-if="!editandoSenha"
              @click="habilitarEdicaoSenha"
              color="primary"
              outlined
            >
              <v-icon left>mdi-key</v-icon>
              Alterar Senha
            </SGPFormBotaoComponent>
            <template v-else>
              <SGPFormBotaoComponent
                @click="cancelarEdicaoSenha"
                color="grey"
                outlined
                class="mr-2"
              >
                Cancelar
              </SGPFormBotaoComponent>
              <SGPFormBotaoComponent
                @click="alterarSenha"
                color="primary"
                :disabled="!senhaValida || loadingUsuario"
              >
                <v-icon left>mdi-check</v-icon>
                Confirmar
              </SGPFormBotaoComponent>
            </template>
          </v-card-actions>
        </v-card>

        <!-- PERFIS E WORKFLOW - COMENTADO PARA EXPANSÃO FUTURA -->
        <!-- 
        <v-card class="mb-4">
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-shield-account</v-icon>
            Perfis da Aplicação
          </v-card-title>
          <v-card-text>
            <PerfilAplicacaoComponent 
              v-for="(perfil, index) in usuario.roles" 
              :key="index" 
              :perfil="perfil" 
            />
            <SGPAlertaComponent v-if="!usuario.roles || !usuario.roles.length">
              Sem perfis configurados
            </SGPAlertaComponent>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" v-if="perfilWorkflow && (perfilWorkflow.tarefas.length || perfilWorkflow.regionais.length)">
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-briefcase</v-icon>
            Perfil Workflow
          </v-card-title>
          <v-card-text>
            <h4 class="mb-3">Tarefas Configuradas</h4>
            <TarefaConfiguradaComponent 
              v-for="(tarefa, index) in perfilWorkflow.tarefas" 
              :key="'tarefa-' + index" 
              :tarefa="tarefa" 
            />
            <SGPAlertaComponent v-if="!perfilWorkflow.tarefas.length" class="mb-4">
              Sem tarefas configuradas
            </SGPAlertaComponent>
            
            <h4 class="mb-3 mt-4">Regionais Configuradas</h4>
            <RegionalConfiguradaComponent 
              v-for="(regional, index) in perfilWorkflow.regionais" 
              :key="'regional-' + index" 
              :regional="regional" 
            />
            <SGPAlertaComponent v-if="!perfilWorkflow.regionais.length">
              Sem regionais configuradas
            </SGPAlertaComponent>
          </v-card-text>
        </v-card>

        <v-card class="mb-4" v-if="perfilWorkflow && perfilWorkflow.equipes.length">
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-account-group</v-icon>
            Equipes
          </v-card-title>
          <v-card-text>
            <EquipeComponent 
              v-for="(equipe, index) in perfilWorkflow.equipes" 
              :key="'equipe-' + index" 
              :equipe="equipe" 
            />
            <SGPAlertaComponent v-if="!perfilWorkflow.equipes.length">
              Sem equipes configuradas
            </SGPAlertaComponent>
          </v-card-text>
        </v-card>
        -->

      </SGPColComponent>
    </SGPRowComponent>
    <SGPLoadingComponent v-if="loadingUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import criarToast from '@/common/boot/ToastsHandler';
// import PerfilAplicacaoComponent from "../components/MeuPerfil/PerfilAplicacaoComponent.vue";
// import TarefaConfiguradaComponent from "../components/MeuPerfil/TarefaConfiguradaComponent.vue";
// import RegionalConfiguradaComponent from "../components/MeuPerfil/RegionalConfiguradaComponent.vue";
// import EquipeComponent from "../components/MeuPerfil/EquipeComponent.vue";

export default {
  components: { 
    // PerfilAplicacaoComponent, 
    // TarefaConfiguradaComponent, 
    // RegionalConfiguradaComponent, 
    // EquipeComponent
  },
  
  name: "MeuPerfilPage",

  data() {
    return {
      editandoDados: false,
      editandoSenha: false,
      dadosUsuario: {
        name: '',
        email: '',
        telefone_1: ''
      },
      dadosOriginais: {},
      senhaData: {
        senha_atual: '',
        nova_senha: '',
        confirmar_senha: ''
      },
      perfilWorkflow: {
        tarefas: [],
        regionais: [],
        equipes: []
      }
    }
  },

  async created() {
    await this.carregarPerfilUsuario();
  },

  computed: {
    ...mapGetters("usuarios", ["loadingUsuario", "usuario"]),
    ...mapGetters("login", ["usuarioLogado"]),

    nomeAvatar() {
      if (!this.usuarioLogado?.nome) return "";

      const nome = this.usuarioLogado.nome.split(" ");
      const primeiroNome = nome[0];
      let ultimoNome = nome[nome.length - 1];

      if (nome.length === 1) {
        ultimoNome = primeiroNome[1] || primeiroNome[0];
      }

      return `${primeiroNome[0]}${ultimoNome[0]}`.toUpperCase();
    },

    senhaValida() {
      return (
        this.senhaData.senha_atual &&
        this.senhaData.nova_senha &&
        this.senhaData.confirmar_senha &&
        this.senhaData.nova_senha === this.senhaData.confirmar_senha &&
        this.senhaData.nova_senha.length >= 6
      );
    }
  },

  methods: {
    ...mapActions("usuarios", ["getUsuario", "atualizarUsuario", "alterarSenhaUsuario"]),

    async carregarPerfilUsuario() {
      try {
        const usuarioLogadoCache = JSON.parse(
          localStorage.getItem("provedores-usuario")
        );

        if (!usuarioLogadoCache?.id) {
          console.error("Usuário não encontrado no localStorage");
          return;
        }

        await this.getUsuario(usuarioLogadoCache.id);

        this.dadosUsuario = {
          name: this.usuario.name || '',
          email: this.usuario.email || '',
          telefone_1: this.usuario.telefone_1 || ''
        };

        this.dadosOriginais = { ...this.dadosUsuario };
      } catch (error) {
        console.error("Erro ao carregar perfil do usuário:", error);
      }
    },

    habilitarEdicao() {
      this.editandoDados = true;
    },

    cancelarEdicao() {
      this.dadosUsuario = { ...this.dadosOriginais };
      this.editandoDados = false;
    },

    async salvarDados() {
      try {
        const usuarioLogadoCache = JSON.parse(
          localStorage.getItem("provedores-usuario")
        );

        const payload = {
          id: usuarioLogadoCache.id,
          ...this.dadosUsuario
        };

        await this.atualizarUsuario(payload);

        this.dadosOriginais = { ...this.dadosUsuario };
        this.editandoDados = false;

        criarToast({
          tipo: 'success',
          mensagem: 'Dados atualizados com sucesso!'
        });

        if (this.dadosUsuario.name !== usuarioLogadoCache.nome) {
          usuarioLogadoCache.nome = this.dadosUsuario.name;
          localStorage.setItem("provedores-usuario", JSON.stringify(usuarioLogadoCache));
        }
      } catch (error) {
        console.error("Erro ao salvar dados:", error);
        criarToast({
          tipo: 'error',
          mensagem: 'Erro ao salvar dados do usuário'
        });
      }
    },

    habilitarEdicaoSenha() {
      this.editandoSenha = true;
    },

    cancelarEdicaoSenha() {
      this.senhaData = {
        senha_atual: '',
        nova_senha: '',
        confirmar_senha: ''
      };
      this.editandoSenha = false;
    },

    async alterarSenha() {
      if (this.senhaData.nova_senha !== this.senhaData.confirmar_senha) {
        criarToast({
          tipo: 'error',
          mensagem: 'As senhas não conferem'
        });
        return;
      }

      if (this.senhaData.nova_senha.length < 6) {
        criarToast({
          tipo: 'error',
          mensagem: 'A senha deve ter no mínimo 6 caracteres'
        });
        return;
      }

      try {
        const usuarioLogadoCache = JSON.parse(
          localStorage.getItem("provedores-usuario")
        );

        await this.alterarSenhaUsuario({
          id: usuarioLogadoCache.id,
          senha_atual: this.senhaData.senha_atual,
          nova_senha: this.senhaData.nova_senha
        });

        this.cancelarEdicaoSenha();

        criarToast({
          tipo: 'success',
          mensagem: 'Senha alterada com sucesso!'
        });
      } catch (error) {
        console.error("Erro ao alterar senha:", error);
        criarToast({
          tipo: 'error',
          mensagem: error.response?.data?.message?.error?.[0] || 'Erro ao alterar senha'
        });
      }
    }
  },
};
</script>

<style scoped>
.perfil-page {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.perfil-header {
  margin-bottom: 30px;
}

.avatar-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.nome-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #1976d2;
  color: white;
  font-size: 48px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.form-label {
  font-weight: 600;
  color: #666;
  font-size: 14px;
  margin-bottom: 4px;
}

.headline {
  font-size: 20px !important;
  font-weight: 500 !important;
  color: #333;
}
</style>